<template>
  <v-card class="mx-auto" elevation="16" max-width="100hv">
    <v-card-item>
      <v-card-title> About / Nosotros </v-card-title>
      <v-card-subtitle>
        <div v-if="language == 'EN'">
          <h3>You are in the section to update in</h3>
          <h3>English</h3>
          <button @click="changeLanguage()" class="action-btn secondary-btn">
            <span class="language-tag">Change Language</span>
            {{ language == "EN" ? "ES" : "EN" }}
          </button>
        </div>

        <div v-else>
          <h3>Estas actualizando la sección en</h3>
          <h3>Español</h3>
          <button @click="changeLanguage()" class="action-btn secondary-btn">
            <span class="language-tag">Cambiar idioma</span>
            {{ language == "ES" ? "EN" : "ES" }}
          </button>
        </div>
        <div class="divider"></div>
      </v-card-subtitle>
    </v-card-item>
    <v-card-text>
      <v-row class="gap-y-6">
        <div class="operations-page">
          <section class="about-hero">
            <div class="hero-overlay about-info-title">
              <h1
                style="color: white !important"
                @dblclick="openEditModal('ABOUT_01_' + language)"
              >
                <span v-html="filterData('ABOUT_01_' + language)"></span>
              </h1>
            </div>
          </section>

          <section class="header_about">
            <v-row class="about-info">
              <v-col cols="12" md="6" sm="6" xs="12" class="frontera-class">
                <h6 style="color: #D32A28 !important" @dblclick="openEditModal('ABOUT_02_' + language)">
                  <span v-html="filterData('ABOUT_02_' + language)"></span>
                </h6>
              </v-col>
              <v-col cols="12" md="6" sm="6" xs="12" class="frontera-class">
                <p @dblclick="openEditModal('ABOUT_03_' + language)">
                  <span v-html="filterData('ABOUT_03_' + language)"></span>
                </p>
              </v-col>
            </v-row>
          </section>

          <section class="about-info">
            <v-row class="text-center">
              <v-col cols="12" md="12">
                <p class="p-big" @dblclick="openEditModal('ABOUT_04_' + language)">
                  <span v-html="filterData('ABOUT_04_' + language)"></span>
                </p>
              </v-col>
            </v-row>
            <v-row class="text-start">
              <v-col cols="12" md="6" sm="6" xs="12">
                <p @dblclick="openEditModal('ABOUT_05_' + language)">
                  <span v-html="filterData('ABOUT_05_' + language)"></span>
                </p>
              </v-col>
              <v-col cols="12" md="6" sm="6" xs="12">
                <p @dblclick="openEditModal('ABOUT_06_' + language)">
                  <span v-html="filterData('ABOUT_06_' + language)"></span>
                </p>
              </v-col>
            </v-row>
          </section>

          <kinesis-container event="scroll">
            <kinesis-element
              :strength="80"
              type="translate"
              axis="y"
              class="mining-cards-parallax"
            >
              <section class="mining-cards"></section>
            </kinesis-element>
          </kinesis-container>

          <section class="strategy-content">
            <v-row class="about-info">
              <v-col cols="12" md="6"  sm="6" xs="12" class="text-center images-content-one">
                <img
                  :src="
                    searchImage('IMAGE_ABOUT_01') !== null
                      ? searchImage('IMAGE_ABOUT_01')
                      : `${BASEURL}/img/img-strategy.jpg`
                  "
                  alt="strategy"
                  @error="
                    (e) => (e.target.src = `${BASEURL}/img/img-strategy.jpg`)
                  "
                  width="400px"
                  style="margin-top: -32px"
                  @dblclick="openEditImageModal('IMAGE_ABOUT_01')"
                />
              </v-col>
              <v-col cols="12" md="6" sm="6" xs="12" class="text-start">
                <div class="strategy-text">
                  <h2 @dblclick="openEditModal('ABOUT_07_' + language)">
                    <span v-html="filterData('ABOUT_07_' + language)"></span>
                  </h2>
                  <p @dblclick="openEditModal('ABOUT_08_' + language)">
                    <span v-html="filterData('ABOUT_08_' + language)"></span>
                  </p>
                  <h6 class="h-big mt-5 mb-5" style="color: #f05a29 !important" @dblclick="openEditModal('ABOUT_09_' + language)">
                    <span v-html="filterData('ABOUT_09_' + language)"></span>
                  </h6>
                </div>
              </v-col>
            </v-row>
          </section>

          <section class="values-content">
            <v-row class="about-info">
              <v-col cols="12" md="6" class="backgroudnd-text-values">
                <div class="strategy-text text-start">
                  <h2 @dblclick="openEditModal('ABOUT_10_' + language)">
                    <span v-html="filterData('ABOUT_10_' + language)"></span>
                  </h2>
                  <p @dblclick="openEditModal('ABOUT_11_' + language)">
                    <span v-html="filterData('ABOUT_11_' + language)"></span>
                  </p>
                </div>
              </v-col>
              <v-col cols="12" md="6" class="text-center images-content">
                <img
                  :src="
                    searchImage('IMAGE_ABOUT_02') !== null
                      ? searchImage('IMAGE_ABOUT_02')
                      : `${BASEURL}/img/img-values.jpg`
                  "
                  @error="
                    (e) => (e.target.src = `${BASEURL}/img/img-values.jpg`)
                  "
                  alt="strategy"
                  width="400px"
                  @dblclick="openEditImageModal('IMAGE_ABOUT_02')"
                />
              </v-col>
            </v-row>
          </section>
        </div>
      </v-row>
    </v-card-text>
  </v-card>
  <UpdateModal
    :visible="dialogVisible"
    :current-text="currentText"
    current-page="ABOUT"
    :text-id="currentTextId"
    @update:visible="updateDialogVisible"
    @save-text="updateText"
  />
  <ModalUpdateImage
    :is-visible-image-u="dialogVisibleImage"
    :image-id="currentImageId"
    image-section="ABOUT"
    @update:visible="updateDialogVisibleImage"
    @update:files="getImages"
  />
</template>

<script>
import { defineComponent, onMounted, ref } from "vue";
import {
  BASEURL,
  getLanguageForUpdateContent,
  setLanguageForUpdateContent,
} from "@/kernel/utils";
import { showInfoToast } from "@/kernel/alerts";
import UpdateModal from "../../components/UpdateModal.vue";
import {
  getSectionByPageandlanguage,
  getImageBySection,
} from "../../services/sections-service";
import ModalUpdateImage from "../../components/ModalUpdateImage.vue";

export default defineComponent({
  name: "UpdateAboutEn",
  components: {
    UpdateModal,
    ModalUpdateImage,
  },
  setup() {
    const dataAbout = ref([
      {
        section_id: "ABOUT_01_EN",
        description: "About Us",
      },
      {
        section_id: "ABOUT_01_ES",
        description: "Sobre nosotros",
      },
      {
        section_id: "ABOUT_02_EN",
        description: "Frontera Copper Corporation",
      },
      {
        section_id: "ABOUT_02_ES",
        description: "Frontera Copper Corporation",
      },
      {
        section_id: "ABOUT_03_EN",
        description:
          "Frontera is a copper mining company that operates the Piedras Verdes mine. The mine is located in southern Sonora, 25 minutes from Alamos and 35 minutes from Navojoa, where most employees live.",
      },
      {
        section_id: "ABOUT_03_ES",
        description:
          "Frontera es una empresa minera de cobre que opera la mina Piedras Verdes, ubicada en el sur de Sonora, a 25 minutos de Álamos y 35 minutos de Navojoa, donde reside la mayoría de los empleados.",
      },
      {
        section_id: "ABOUT_04_EN",
        description:
          "Piedras Verdes is an open-pit copper mine that operates on a conventional basis with a mining rate of ~135ktpd and processes it ore by heap leaching and Solvent Extraction & Electrowinning.",
      },
      {
        section_id: "ABOUT_04_ES",
        description:
          "Piedras Verdes es una mina de cobre a cielo abierto que opera de forma convencional con una tasa de extracción de ~200ktpd y procesos de lixiviación en pila y SX/EW",
      },
      {
        section_id: "ABOUT_05_EN",
        description:
          "PV mines and processes sulfide and oxide ores, produces London Metals Exchange Grade “A” copper cathodes, and sells primarily hypogene ore that cannot be economically processed by heap leachng to Kupari Metals, an independently-owned tolling company that produces and sells copper concentrates.",
      },
      {
        section_id: "ABOUT_05_ES",
        description:
          "Extrae y procesa minerales de sulfuro y óxido, produce cátodos de cobre de grado 'A' en la Bolsa de Metales de Londres y vende principalmente mineral hipógeno a Kupari Metals, una empresa de propiedad independiente que produce y vende concentrados de cobre.",
      },
      {
        section_id: "ABOUT_06_EN",
        description:
          "Fully integrated with the CFE power grid and other infrastructure. All water is sourced from within the mine footprint. Within 1 hour and 15 minutes from two airports. The Ciudad Obregón International Airport operates ~20 commercial flights daily.",
      },
      {
        section_id: "ABOUT_06_ES",
        description:
          "Totalmente integrada con la red eléctrica de la CFE y otras infraestructuras. Toda el agua procede de la huella de la mina. A menos de 1 hora y 15 minutos de dos aeropuertos, el aeropuerto internacional de Ciudad Obregón opera unos 20 vuelos comerciales al día.",
      },
      {
        section_id: "ABOUT_07_EN",
        description: "Strategy",
      },
      {
        section_id: "ABOUT_07_ES",
        description: "Estrategia",
      },
      {
        section_id: "ABOUT_08_EN",
        description:
          "PV prioritizes safety, care for the community, and sustainability. It will continue to optimize capacity and recovery rates by maximizing the productivity of the mining fleet, minimizing mining dilution as the deposit becomes more highly disseminated, and selectively investing in enhanced processes focused on increasing crushing capacity, the proportion of crushed leach ore that is agglomerated and ore sorting. Investment decisions are driven by payback, internal rates of return, and their carbon footprint. As and when copper prices continue to increase, such investments will become increasingly compelling.",
      },
      {
        section_id: "ABOUT_08_ES",
        description:
          "PV continuará optimizando la capacidad y las tasas de recuperación maximizando la productividad de la flota minera, minimizando la dilución minera a medida que el yacimiento se vuelve más diseminado e invirtiendo selectivamente en procesos mejorados centrados en el aumento de la capacidad de trituración y la proporción de mineral de lixiviación triturado que se aglomera. Las decisiones de inversión serán impulsadas por la recuperación de la inversión y en las tasas internas de retorno y su huella de carbono. A medida que los precios del cobre sigan aumentando, estas inversiones serán cada vez más atractivas.",
      },
      {
        section_id: "ABOUT_09_EN",
        description:
          "This will occur while prioritizing safety, care for the community and sustainability.",
      },
      {
        section_id: "ABOUT_09_ES",
        description:
          "Esto ocurrirá mientras se prioriza la seguridad, el cuidado de la comunidad y la sostenibilidad.",
      },
      {
        section_id: "ABOUT_10_EN",
        description: "Values",
      },
      {
        section_id: "ABOUT_10_ES",
        description: "Valores",
      },
      {
        section_id: "ABOUT_11_EN",
        description:
          "Our core values are focussed on the health, safety and wellbeing of our employees, contractors and other stakeholders, we operate to world-class environmental, social, and governance standards.",
      },
      {
        section_id: "ABOUT_11_ES",
        description:
          "Nuestros valores fundamentales incluyen la salud y la seguridad de nuestros empleados y contratistas, y el compromiso de operar de acuerdo con las normas ambientales, sociales y estándares gubernamentales.",
      },
    ]);

    const filterData = (found_id) => {
      const filteredData = dataAbout.value.filter(
        (item) => item.section_id === found_id
      );
      return filteredData.length > 0 ? filteredData[0].description : null;
    };

    const changeLanguage = () => {
      const lang = getLanguageForUpdateContent() === "EN" ? "ES" : "EN";
      setLanguageForUpdateContent(lang);
      showInfoToast(
        `Language changed to ${lang === "EN" ? "English" : "Spanish"}`
      );
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    };

    const dialogVisible = ref(false);
    const currentText = ref("");
    const currentTextId = ref("");

    const updateDialogVisible = (visible) => {
      dialogVisible.value = visible;
    };

    const updateText = ({ id, text }) => {
      const index = dataAbout.value.findIndex((item) => item.section_id === id);
      if (index !== -1) {
        dataAbout.value[index].description = text;
      }
    };

    const openEditModal = (textId) => {
      showInfoToast(`Double click to edit the text: ${textId}`);
      const textToEdit = filterData(textId);
      currentText.value = textToEdit;
      currentTextId.value = textId;
      dialogVisible.value = true;
    };

    const fetchData = async () => {
      try {
        const dataForm = {
          page: "ABOUT",
          language: getLanguageForUpdateContent(),
        };
        const response = await getSectionByPageandlanguage(dataForm);
        if (response.status === 200) {
          if (parseInt(response.data.length) !== 0) {
            dataAbout.value = response.data;
          } else {
            showInfoToast("Watching for cache data");
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const imagesAbout = ref([]);

    const dialogVisibleImage = ref(false);
    const currentImageId = ref("");

    const updateDialogVisibleImage = (visible) => {
      dialogVisibleImage.value = visible;
    };

    const openEditImageModal = (imageId) => {
      showInfoToast(`Double click to edit the image: ${imageId}`);
      currentImageId.value = imageId;
      dialogVisibleImage.value = true;
    };

    const searchImage = (imageId) => {
      const foundImage = imagesAbout.value.find(
        (image) => image.image_id === imageId
      );
      return foundImage ? BASEURL + foundImage.image_path : null;
    };

    const getImages = async () => {
      try {
        const dataForm = {
          page: "ABOUT",
        };
        const result = await getImageBySection(dataForm);
        if (result.status === 200) {
          if (result.data.content !== null) {
            imagesAbout.value = result.data.content;
          }
        }
      } catch (error) {
        console.log("Error fetching images:", error);
      }
    };

    onMounted(() => {
      fetchData();
      getImages();
    });

    return {
      BASEURL,
      language: getLanguageForUpdateContent(),
      changeLanguage,
      filterData,
      openEditModal,
      updateDialogVisible,
      updateText,
      dialogVisible,
      currentText,
      currentTextId,
      dialogVisibleImage,
      currentImageId,
      updateDialogVisibleImage,
      openEditImageModal,
      searchImage,
      getImages,
    };
  },
});
</script>

<style scoped>
.images-content-one {
  z-index: 2;
  position: relative;
}

.images-content {
  max-height: 900px;
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
  z-index: 2;
  margin-top: -100px;
}

.images-content img {
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
  object-position: center;
  width: 100%;
  height: auto;
}

.operations-page {
  color: #333;
  line-height: 1.6;
  width: 100%;
  overflow-x: hidden;
  position: relative;
  }

/* Hero Section - Full Width */
.about-hero {
  height: 60vh;
  background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
    url("https://api3.cobredelmayo.com/api/public/img/bg-about.jpg") center/cover no-repeat;
   display: flex !important;
  align-items: end !important;
  justify-content: start !important;
  text-align: end !important;
  color: white !important;
  position: relative;
  width: 100vw;
  left: 50%;
  right: 50%;
  margin-left: -50vw !important;
  margin-right: -50vw !important;
}

.hero-overlay {
  z-index: 1;
}

.about-hero h1 {
  font-size: 3.5rem;
  margin-bottom: 1rem;
  border: 0px solid transparent;
}

.operations-container {
  color: #333;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  margin-top: 92px !important;
}

.frontera-class {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}



/* Estilos del mining and process */
.header_about {
  color: #333;
  background-image: url("@/assets/bg-about-1.png");
  background-size: cover;
  background-position: center;
  background-color: #E4E5E5;
  background-repeat: no-repeat;
  box-sizing: border-box;
}



.about-info {
  color: #333;
}



/* Estilos de las cards */
.mining-cards-parallax {
  will-change: transform;
  display: block;
}

.mining-cards {
  margin-top: 24px;
  padding: 80px 0;
  background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.1)),
    url("@/assets/bg-located.jpg") center/cover
      no-repeat;
  height: 60vh;
  background-attachment: fixed; /* Opcional si quieres efecto clásico */
  z-index: -99;
}

@media screen and (max-width: 768px) {
  .mining-cards {
    background-attachment: scroll; /* Cambia a scroll en pantallas pequeñas */
  }
}

/* Estilos de la estrategia */
.strategy-content {
  color: #333;
  max-width: auto;
  background: #e4e5e5;
  padding-top: 48px;
  padding-bottom: 48px;
  padding-left: 64px;
  padding-right: 128px;
}

.strategy-content img {
  position: static;
  z-index: 999;
  margin-left: -128;
}

.strategy-text {
  padding: 20px;
  margin-top: 56px !important;
}


/* Estilos de los valores */
.values-content {
  color: #333;
  background-color: #f05a29;
}

.backgroudnd-text-values {
  background-color: #f9e1cd;
  padding: 20px;
  max-width: 600px;
  height: 450px;
  margin-top: -56px;
  margin-right: -56px;
  position: relative;
}

.backgroudnd-text-values img {  
  margin-left: -228px;
  position: relative;
  z-index: 999;
}

@media screen and (max-width: 768px) {
  .operations-container {
    padding: 10px;
  }
  .strategy-content img {
    width: 100%;
    margin-top: -32px;
  }

  .strategy-content {
    height: auto;
    padding: 24px;
  }

  .backgroudnd-text-values {
    margin-left: 0 !important;
    margin-right: 0 !important;
    margin-top: 0px !important;
    margin-bottom: 172px !important;
    max-width: 100%;
    height: auto;
  }
}
/* Estilos de la tarjeta */
.language-tag {
  font-size: 0.75rem;
  background: rgba(255, 255, 255, 0.2);
  padding: 2px 6px;
  border-radius: 4px;
}
.action-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.secondary-btn {
  background: #f59e0b;
  color: white;
}

.secondary-btn:hover {
  background: #d97706;
  box-shadow: 0 4px 6px rgba(245, 158, 11, 0.3);
}
</style>
